import { BookingPricingModelType } from 'parkdepot-shared/gql/graphql'

export interface Lot {
    id: string
    image_urls: string[]
    opening_hours: OpeningHours
    name: string
    is_live: boolean
    description: {
        [key: string]: string
    }
    address: string
    city: string
    cityName?: string
    active_features: ActiveFeature[]
    openingHours?: OpeningHoursObject[]
    banner?: string | null
    disabled?: boolean
    prices: Prices[]
    latitude?: number
    longitude?: number
    earliest_booking_date: string
    end_of_live_date: string
    lot_country_code: string
    min_booking_duration?: string
    max_booking_duration?: string
}

export interface OpeningHoursObject {
    firstDay: string | undefined
    lastDay: string | undefined
    openingTime: string
    closingTimeString: string
    daysCount: number
    daysIncluded: string[]
    fullOpeningHoursList?: {
        key?: string
        text?: string
    }[]
}

export interface Prices {
    hour: number
    day: number
    week: number
    month: number
    pricing_type: BookingPricingModelType
}

export interface OpeningHours {
    opening_hours_rrules: {
        duration: string | null
        rrule: string | null
    }[]
}

export interface ActiveFeature {
    config: {
        iso_duration?: string
        rrule?: string
        night_parking_times?: {
            rrule: string
            iso_duration: string
        }[]
    }
    enabled: boolean
    name: string
}

export interface Schedule {
    rrule: string
    duration: string
}

export enum LotViewName {
    ALL = 'ALL',
    HOURLY = 'HOURLY_BOOKING',
    DAILY = 'DAILY_BOOKING',
    SUBSCRIPTION = 'SUBSCRIPTION',
    NIGHTLY = 'NIGHT_PARKING'
}

// lower case because it's used in the url
export enum LotDurationType {
    SHORT = 'short',
    LONG = 'long',
    SUBSCRIPTION = 'subscription',
    NIGHT = 'night'
}

export enum LotRoutingState {
    LOADING = 'LOADING',
    GENERIC_ERROR = 'GENERIC_ERROR',
    NOT_LIVE_ERROR = 'NOT_LIVE_ERROR',
    LOT_END_OF_LIVE_ERROR = 'LOT_END_OF_LIVE_ERROR',
    LOT_HOURLY_TOO_EARLY_ERROR = 'LOT_HOURLY_TOO_EARLY_ERROR',
    HOURLY = 'HOURLY',
    DAILY = 'DAILY',
    NIGHTLY = 'NIGHTLY',
    SUBSCRIPTION = 'SUBSCRIPTION'
}
